import { css } from '@emotion/css';

export const dialogStyles = (width: number = 41.6) => css`
  width: ${width}rem;
`;

export const textAreaInputStyles = css`
  .MuiInputBase-input {
    padding: 0 16px;
    margin: 12px 0;
  }
`;
